const INITIAL_STATE = {
  status: "PENDING",
  activation_status: "READY"
}

export default INITIAL_STATE
